import type { PiletApi } from '@chess/platform-web';
import { ANALYSIS_API, createAnalysis } from '@chess/api-analysis';
import { CHESS_API, type Chess } from '@chess/api-chess';
import { ENGINE_API, type Engine } from '@chess/api-engine';
import { GAMES_API, type Games } from '@chess/api-games';
import { LOG_API, type Log } from '@chess/api-log';

// Provides `analysis`: the whole-game scan, run over the `engine` and kept
// in each game's `analysis/scan.json` through the games API. The scanning
// rules are the api package's reference implementation; this plugin only
// wires it to the app's engine, store and rules, and picks the depth.
const DEPTH = 12;

export function setup(app: PiletApi) {
  void Promise.all([
    app.getApi<Engine>(ENGINE_API),
    app.getApi<Games>(GAMES_API),
    app.getApi<Chess>(CHESS_API),
    app.getApi<Log>(LOG_API),
  ]).then(([engine, games, chess, log]) => {
    app.registerApi(ANALYSIS_API, createAnalysis({ engine, games, chess, depth: DEPTH, log: log.child(app.meta.name) }));
  });
}
